import lockBlackSvg from '../assets/images/game/lock_black.svg';
import yellowOverArrowSvg from '../assets/images/game/arrow_up_yellow.svg';
import yellowUnderArrowSvg from '../assets/images/game/arrow_down_yellow.svg';
import whiteOverArrowSvg from '../assets/images/game/arrow_up_white.svg';
import whiteUnderArrowSvg from '../assets/images/game/arrow_down_white.svg';
import greenUnderArrowSvg from '../assets/images/game/arrow_down_green.svg';
import greenOverArrowSvg from '../assets/images/game/arrow_up_green.svg';
import winBlockBackgroundPng from '../assets/images/game/wining-block.png';
import coinsPng from '../assets/images/game/coins.png';
import { betTypes } from '../enums';
import { isMobile } from '@pascal/pascal-core';
import { roundsInfoStore } from '../store';
import { getGameCanvasStandards } from "../helpers/gameCanvasHelper";

export const rangeBetBlockSize = {
  width: 100,
  height: 50
}

const lockImg = document.createElement('img');
lockImg.src = lockBlackSvg;

const yellowOverArrowImg = document.createElement('img');
yellowOverArrowImg.src = yellowOverArrowSvg;

const whiteOverArrowImg = document.createElement('img');
whiteOverArrowImg.src = whiteOverArrowSvg;

const yellowUnderArrowImg = document.createElement('img');
yellowUnderArrowImg.src = yellowUnderArrowSvg;

const whiteUnderArrowImg = document.createElement('img');
whiteUnderArrowImg.src = whiteUnderArrowSvg;

const greenUnderArrowImg = document.createElement('img');
greenUnderArrowImg.src = greenUnderArrowSvg;

const greenOverArrowImg = document.createElement('img');
greenOverArrowImg.src = greenOverArrowSvg;

const winBlockBackgroundImg = document.createElement('img');
winBlockBackgroundImg.src = winBlockBackgroundPng;

const coinsImg = document.createElement('img');
coinsImg.src = coinsPng;

export const lineIntervals = {
  vertical: 100,
  horizontal: 50,
};

export const canvasConfig = {
  width: isMobile() ? 1955 : 1100,
  height: 1100,
};

export const colors = {
  background: '#000000',
  gold: '#fdc11e',
  linesStroke: '#242437',
  lineFill: '#131319',
  lightBlue: '#3d8c8c',
};

export const pendingBetBlock = {
  odd: { color: 'white', fontSize: 13, xDiff: 5, yDiff: 20 },
  amount: { color: 'white', fontSize: 15, xDiff: 5, yDiff: 40 },
  strokeColor: '#BB0167',
  grd: {
    color1: '#B55B8C',
    color2: '#88004B',
    y1: 0,
    y2: 35,
  },
  icons: [{ img: lockImg, xDiff: 85, yDiff: 5, w: 10, h: 10 }],
  texts: [],
};

export const wonBetBlock = {
  odd: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 13, xDiff: 5, yDiff: 20 },
  amount: { color: colors.gold, fontSize: 15, xDiff: 5, yDiff: 40 },
  strokeColor: '#64C7AC',
  grd: {
    color1: '#64C7AC',
    color2: '#155A47',
    y1: 5,
    y2: 45,
  },
  icons: [],
  texts: [],
};

export const loseBetBlock = {
  odd: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 13, xDiff: 5, yDiff: 20 },
  amount: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 15, xDiff: 5, yDiff: 40 },
  strokeColor: '#454545',
  grd: {
    color1: '#979797',
    color2: '#7E7E7E',
    y1: 5,
    y2: 45,
  },
  icons: [],
  texts: [],
};

export const rangeBetBlock = {
  odd: { color: 'white', fontSize: 13, xDiff: 5, yDiff: 20 },
  amount: { color: colors.gold, fontSize: 15, xDiff: 5, yDiff: 40 },
  strokeColor: '#454545',
  grd: {
    color1: '#6D6D6D',
    color2: '#2F2F2F',
    y1: 0,
    y2: 40,
  },
  icons: [],
  texts: [],
};

export const clickedRangeBetBlock = {
  odd: { color: 'white', fontSize: 13, xDiff: 5, yDiff: 20 },
  amount: { color: 'white', fontSize: 15, xDiff: 5, yDiff: 40 },
  strokeColor: '#BB0167',
  grd: {
    color1: '#FF47AC',
    color2: '#8B064F',
    y1: 0,
    y2: 40,
  },
  icons: [],
  texts: [],
};

export const overBetBlock = {
  odd: { color: 'white', fontSize: 17, xDiff: 5, yDiff: 20 },
  amount: { color: colors.gold, fontSize: 19, xDiff: 5, yDiff: 45 },
  strokeColor: '#4a4b4d',
  grd: {
    color1: '#585858',
    color2: '#414141',
    y1: 7,
    y2: 65,
  },
  icons: [{ img: yellowOverArrowImg, xDiff: 105, yDiff: 0, w: 45, h: 45 }],
  texts: [
    {
      color: 'white',
      fontSize: 15,
      yDiff: 66,
      get xDiff() {
        const { ctx } = getGameCanvasStandards();
        const endPos = 145;
        return endPos - ctx.measureText(this.content).width;
      },
      get content() {
        return roundsInfoStore.higher;
      },
    },
  ],
};

export const clickedOverBetBlock = {
  odd: { color: 'white', fontSize: 17, xDiff: 5, yDiff: 20 },
  amount: { color: 'white', fontSize: 19, xDiff: 5, yDiff: 45 },
  strokeColor: '#BB0167',
  grd: {
    color1: '#B55B8C',
    color2: '#88004B',
    y1: 0,
    y2: 90,
  },
  icons: [{ img: whiteOverArrowImg, xDiff: 105, yDiff: 0, w: 45, h: 45 }],
  texts: [
    {
      color: 'white',
      fontSize: 15,
      get xDiff() {
        const { ctx } = getGameCanvasStandards();
        const endPos = 145;
        return endPos - ctx.measureText(this.content).width;
      },
      yDiff: 66,
      get content() {
        return roundsInfoStore.higher;
      },
    },
  ],
};

export const underBetBlock = {
  odd: { color: 'white', fontSize: 17, xDiff: 5, yDiff: 20 },
  amount: { color: colors.gold, fontSize: 19, xDiff: 5, yDiff: 45 },
  strokeColor: '#454545',
  grd: {
    color1: '#585858',
    color2: '#414141',
    y1: 7,
    y2: 65,
  },
  icons: [{ img: yellowUnderArrowImg, xDiff: 105, yDiff: 30, w: 45, h: 45 }],
  texts: [
    {
      color: 'white',
      fontSize: 15,
      get xDiff() {
        const { ctx } = getGameCanvasStandards();
        const endPos = 145;
        return endPos - ctx.measureText(this.content).width;
      },
      yDiff: 20,
      get content() {
        return roundsInfoStore.lower;
      },
    },
  ],
};

export const clickedUnderBetBlock = {
  odd: { color: 'white', fontSize: 17, xDiff: 5, yDiff: 20 },
  amount: { color: 'white', fontSize: 19, xDiff: 5, yDiff: 45 },
  strokeColor: '#BB0167',
  grd: {
    color1: '#B55B8C',
    color2: '#88004B',
    y1: 0,
    y2: 90,
  },
  icons: [{ img: whiteUnderArrowImg, xDiff: 105, yDiff: 30, w: 45, h: 45 }],
  texts: [
    {
      color: 'white',
      fontSize: 15,
      get xDiff() {
        const { ctx } = getGameCanvasStandards();
        const endPos = 145;
        return endPos - ctx.measureText(this.content).width;
      },
      yDiff: 20,
      get content() {
        return roundsInfoStore.lower;
      },
    },
  ],
};

export const loseOverBetBlock = {
  odd: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 17, xDiff: 5, yDiff: 20 },
  amount: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 19, xDiff: 5, yDiff: 45 },
  strokeColor: '#454545',
  grd: {
    color1: '#979797',
    color2: '#7E7E7E',
    y1: 30,
    y2: 90,
  },
  icons: [{ img: whiteOverArrowImg, xDiff: 105, yDiff: 0, w: 45, h: 45 }],
  texts: [
    {
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: 15,
      get xDiff() {
        const { ctx } = getGameCanvasStandards();
        const endPos = 145;
        return endPos - ctx.measureText(this.content).width;
      },
      yDiff: 66,
      get content() {
        return roundsInfoStore.higher;
      },
    },
  ],
};

export const loseUnderBetBlock = {
  odd: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 17, xDiff: 5, yDiff: 20 },
  amount: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 19, xDiff: 5, yDiff: 45 },
  strokeColor: '#454545',
  grd: {
    color1: '#979797',
    color2: '#7E7E7E',
    y1: 30,
    y2: 150,
  },
  icons: [{ img: whiteUnderArrowImg, xDiff: 105, yDiff: 30, w: 45, h: 45 }],
  texts: [
    {
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: 15,
      get xDiff() {
        const { ctx } = getGameCanvasStandards();
        const endPos = 145;
        return endPos - ctx.measureText(this.content).width;
      },
      yDiff: 20,
      get content() {
        return roundsInfoStore.lower;
      },
    },
  ],
};

export const wonOverBetBlock = {
  odd: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 13, xDiff: 5, yDiff: 20 },
  amount: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 12, xDiff: 5, yDiff: 45 },
  strokeColor: '#07841b',
  grd: {
    color1: '#224800',
    color2: '#224800',
    y1: 30,
    y2: 150,
  },
  icons: [{ img: greenOverArrowImg, xDiff: 105, yDiff: 0, w: 45, h: 45 }],
  texts: [
    {
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: 15,
      get xDiff() {
        const { ctx } = getGameCanvasStandards();
        const endPos = 145;
        return endPos - ctx.measureText(this.content).width;
      },
      yDiff: 66,
      get content() {
        return roundsInfoStore.higher;
      },
    },
  ],
};

export const wonUnderBetBlock = {
  odd: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 13, xDiff: 5, yDiff: 20 },
  amount: { color: 'rgba(255, 255, 255, 0.8)', fontSize: 12, xDiff: 5, yDiff: 45 },
  strokeColor: '#07841b',
  grd: {
    color1: '#224800',
    color2: '#224800',
    y1: 30,
    y2: 150,
  },
  icons: [{ img: greenUnderArrowImg, xDiff: 105, yDiff: 30, w: 45, h: 45 }],
  texts: [{ color: 'rgba(255, 255, 255, 0.8)', fontSize: 15, xDiff: 65, yDiff: 20, content: 'BET' }],
};


export const betBlocksByTypes = {
  [betTypes.under]: {default: underBetBlock, clicked: clickedUnderBetBlock},
  [betTypes.over]: {default: overBetBlock, clicked: clickedOverBetBlock},
  [betTypes.range]: {default: rangeBetBlock, clicked: clickedRangeBetBlock},
};
